import Vue from 'vue';


export default function AnonymousOnlyGuard(to, from, next) {
	if(Vue.$auth.authenticated) 
		next('/');				
	else 
		next();				
};